import { Meta, Title } from '@angular/platform-browser';
import {Component, OnInit,ViewChild, ElementRef} from '@angular/core';
import {HttpClient } from '@angular/common/http';
import {Router, ActivatedRoute, Params} from '@angular/router';
import {environment as env} from '../../../environments/environment';
import {Productlist} from '../../models/productlist';
import {ProductsService} from '../../services/products.service'; 
import {CartService} from '../../services/cart.service';
import {SiteuserService} from '../../services/siteuser.service';
import {LanguageService} from '../../services/language.service'; 
import {Category} from '../../models/category';
import { OrderonlineServiceService } from '../../services/orderonline-service.service';

@Component({ 
  selector: 'app-product-lists',
  templateUrl: './product-lists.component.html',
  styleUrls: ['./product-lists.component.css']
})
export class ProductListsComponent implements OnInit {
  @ViewChild('cmodel') cmodel;
  @ViewChild('closeBtn') closeBtn;
  orderOnlineBanner = [];
  cats:Category[] = [];
  prdlist:Productlist[]=[];
  tmpAr = [];
  isEmpty:boolean = false;
  error:string;
  imgurl:string; 
  catslug:string;
  catName:string;
  catNameAr:string;
  storedCart = [];
  addOns = [];
  varientOpt = [];
  productExist:boolean;
  isLoading:boolean;
  cartMsg:string; 
  cartMsg_ar:string;
  existPid:number;
  rpId:number;
  showLang:string;
  parentCatid:any;

  constructor(private srvprod:ProductsService,
     private srvcart:CartService,
     private http:HttpClient,
     private router:Router,
     private usrObj:SiteuserService, 
     private langObj:LanguageService,
     private route:ActivatedRoute,
     private orderOnlieService:OrderonlineServiceService,
     private title: Title,private meta: Meta) {
      this.imgurl =  env.imgurl;

      this.langObj.langStr.subscribe((data)=>{
        this.showLang = data;
      });
    }

  ngOnInit(): void {
     this.showLang = localStorage.getItem("showLang");
     if(this.showLang == null && this.showLang == undefined){
      this.showLang = 'en';
     }


    window.scroll(0,600);

    this.isLoading = true;
    this.orderOnlieService.orderOnlineBanner('Order Now Banner').subscribe((data:any)=>{
      this.orderOnlineBanner = data.data[0];
    });

    this.srvprod.getallcats().subscribe(data => {
      if(data['data'].length <= 0){this.isEmpty = true;}
      this.cats = data['data'];
    },error=> {this.error  = error.message;});

    this.route.params.subscribe((params:Params)=>{
      if(params['catslug']){
        this.catslug = params['catslug'];
      }else{this.catslug = 'hot-appetizers';}

      this.prdlist = []; 
      this.srvprod.getProductsBySlug(this.catslug).subscribe(data => {
        this.isLoading = false;
        this.catName = data['data']['data'][0]['cname'];
        this.catNameAr = data['data']['data'][0]['cname_ar'];

        let catMetaTitle = data['category']['cMetaTitle'];
        let catMetaDesc = data['category']['cMetaDesc'];
        let catMetaKey = data['category']['cMetaKeywords'];
        this.parentCatid = data['category']['pcategory_id'];

        //console.log(this.parentCatid);

        if(catMetaTitle == null){
          catMetaTitle = this.catName;
        }
        if(catMetaDesc == null){
          catMetaDesc = this.catName;
        }
        if(catMetaKey == null){
          catMetaKey = this.catName;
        }


        this.title.setTitle(catMetaTitle);
        this.meta.updateTag({ name: 'description', content: catMetaDesc });
        this.meta.updateTag({ name: 'keywords', content: catMetaKey});

        data['data']['data'].map((el)=>{ 
          this.prdlist.push(new Productlist(el.id, el.pName, el.pName_ar, el.pSlug, el.pImage, el.price, 'AED', el.pdescription,el.pdescription_ar ,el.cslug,el.wishlistProductId, el.out_stock, el.pQty, el.isFeast, el.pcategory_id, el.isRestricted));
        })
      },error=> {this.error  = error.message;});  

      //console.log(this.prdlist); 
    })

    
  }
 

  addtoCart(prod,id,price,finalprice,qty,image, pslug, slug,pname_ar, pQty){

    if(this.parentCatid == 19){
      if(pQty == 0){
        this.cartMsg = "Please select fewer quantity and try.";
        this.cmodel.nativeElement.click();
        setTimeout (() => {this.closeBtn.nativeElement.click();}, 4000);
        return;
      }
    }

    var priceWithaddon = (parseFloat(finalprice) / qty ).toFixed(2);
    var produrl = '/product/'+pslug+'/'+slug;
    let prodArray = {
      "pName": prod,
      "pName_ar": pname_ar,
      "pId": id,
      "pImage": image,
      "pslug":slug,
      "catslug":pslug,
      "pUrl":produrl,
      "basePrice": price,
      "totalPrice": finalprice,
      "priceWithaddon": priceWithaddon,
      "qty": qty,
      "addons": this.addOns,
      "varients": this.varientOpt,
      "parentCatid": this.parentCatid,
      "avlpQty": pQty,
      "sno": Date.now()
    };
    this.cartMsg = "Item has been added to the cart";
    this.cartMsg_ar = "تمت إضافة العنصر إلى سلة التسوق";
    this.productExist = false;
    this.storedCart = JSON.parse(localStorage.getItem("cartData"));
    if(this.storedCart != null && this.storedCart.length > 0){
      for(var i=0; i < this.storedCart.length; i++){
        if(this.storedCart[i].pId == prodArray.pId){
          this.productExist  = true;
          this.storedCart[i].qty = this.storedCart[i].qty + 1;
          if(this.parentCatid == 19 && pQty != null){
              if(this.storedCart[i].qty > pQty){
                this.cartMsg = "Please select fewer quantity and try.";
                this.cmodel.nativeElement.click();
                setTimeout (() => {this.closeBtn.nativeElement.click();}, 4000);
                return;
              }
          }
          
          this.storedCart[i].totalPrice = this.storedCart[i].priceWithaddon * this.storedCart[i].qty;
        }
      }
      
      localStorage.setItem("cartData", JSON.stringify(this.storedCart));

      if(this.productExist == false){ 
        this.storedCart.push(prodArray);
        localStorage.setItem("cartData", JSON.stringify(this.storedCart));
        this.srvcart.cartItemCount();
        //this.router.navigate(['/cart']);
        this.cmodel.nativeElement.click();
        setTimeout (() => {this.closeBtn.nativeElement.click();}, 1000);
      }else{
        this.cartMsg = "Cart updated successfully";
        this.cartMsg_ar = "تم تحديث سلة التسوق بنجاح";
        this.cmodel.nativeElement.click();
        
        setTimeout (() => {
          this.closeBtn.nativeElement.click();
        }, 2000);
      }
    }else{
      var cartArray = [];
      cartArray.push(prodArray);
      localStorage.setItem("cartData", JSON.stringify(cartArray));

      this.srvcart.cartItemCount();
      this.cmodel.nativeElement.click();
      setTimeout (() => {
        this.closeBtn.nativeElement.click();
     }, 2000);
    }

  }

  addtoWishlist(pid){
    if(this.usrObj.loggedIn() == true){
      var userId = localStorage.getItem("sajid");
      this.orderOnlieService.addTowishlist(pid, userId).subscribe((data:any)=>{
        if(data['success']){
          if(data['data'] !=''){
            this.rpId = pid;
            this.cartMsg = "Item added to favorites";
            this.cartMsg_ar = "تمت إضافة العنصر إلى المفضلة";
            this.cmodel.nativeElement.click();
            setTimeout (() => {this.closeBtn.nativeElement.click();}, 1000);
          }else{
            this.cartMsg = "Item already in favorites";
            this.cartMsg_ar = "العنصر موجود بالفعل في المفضلة";
            this.cmodel.nativeElement.click();

            setTimeout (() => {
            this.closeBtn.nativeElement.click();
            }, 2000);
          }
        }
      });

    }else{
      this.router.navigate(['/login', {wishlist:1}]);
    }

  }
} 